import GoodTimesFontText from '@/TRC/components/goodTimesFontText';
import VideoReaction from '../../../../../Pages/VideoPlayer/components/VideoReaction';
import { formatDisplayDate } from '@/component/formatDisplayDate';
import { useTrcCategoryForDynamicButton } from '@/TRC/hooks/useTrcCategoryForDynamicButton';
import { Grid, Box } from '@mui/material';
import useResize, { deviceTypesEnum } from '@/hook/useResize';

const Actions = ({ content, category: propCategory, setPdfView }) => {
	const { displayCategory, buttonLabel } = useTrcCategoryForDynamicButton(propCategory);
	const deviceType = useResize();

	if (deviceType === deviceTypesEnum.mobile) {
		return (
			<Box
				className="text-white"
				sx={{
					backgroundColor: '#FFFFFF33',
					borderRadius: '0.75rem'
				}}
			>
				<Box sx={{ p: 2 }}>
					<Grid container alignItems="left">
						<Grid item xs={8} md={7}>
							<Box className="d-flex flex-column" sx={{ px: '0.1rem', py: 0 }}>
								<span>{displayCategory}</span>

								<span className="d-flex flex-row">
									<span>{content?.pages} Pages</span>
								</span>
							</Box>
						</Grid>

						<Grid
							item
							xs={3}
							md={5}
							sx={{
								display: 'flex',
								justifyContent: { xs: 'flex-start', md: 'flex-end' },
								marginLeft: { xs: '-1rem', md: 0 }
							}}
						>
							<VideoReaction videoId={content?._id} type="lesson-plan" />
						</Grid>
					</Grid>
				</Box>

				<Box
					className="d-flex"
					sx={{
						flexDirection: { xs: 'column' }
					}}
				>
					<button
						style={{
							border: 'none',
							backgroundColor: '#097DAC',
							borderRadius: '0.75rem',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							padding: '0.5rem 1rem'
						}}
						onClick={() => setPdfView(true)}
					>
						<GoodTimesFontText styles={{ marginTop: '0.6rem' }}>{buttonLabel}</GoodTimesFontText>
					</button>
				</Box>
			</Box>
		);
	}

    return (
      <div
        className="pdf-action-container d-flex flex-lg-row flex-column justify-content-between text-white"
        style={{ backgroundColor: '#FFFFFF33', padding: '1rem', borderRadius: '0.75rem' }}
      >
        <div className="d-flex flex-column">
          <span>{displayCategory}</span>
  
          <span className="d-flex flex-row gap-1">
            <div className="vertical-divider" />
            <span>{content?.pages} Pages</span>
          </span>
        </div>
  
        <div className="d-flex flex-lg-row flex-column gap-lg-3">
          <VideoReaction videoId={content?._id} type="lesson-plan" />
          <button
            style={{
              border: 'none',
              backgroundColor: '#097DAC',
              borderRadius: '1rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0.5rem 1rem'
            }}
            onClick={() => setPdfView(true)}
          >
            <GoodTimesFontText styles={{ marginTop: '0.6rem' }}>
              {buttonLabel}
            </GoodTimesFontText>
          </button>
        </div>
      </div>
    );
};

export default Actions;